import Http from '@/utils/http'
const baseUrl = '/app/student'

/**
 *是否助教身份
 * @param classId
 * 
*/

export const assistantInfo = classId => Http.get(`${baseUrl}/assistant/${classId}` )

/**
 *助教权限
 * @param classId
 * 
*/

export const assistantPermission = classId => Http.get(`${baseUrl}/assistant/${classId}/permission` )
